module.exports = __webpack_public_path__ + "static/media/t.207c799d.svg";